import { Button, Dialog, DialogActions, DialogTitle, IconButton } from '@mui/material'
import React from 'react'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'

interface RemoveImageDialogProps {
    onRemove: () => void
}

const RemoveImageDialog: React.FC<RemoveImageDialogProps> = ({ onRemove }: RemoveImageDialogProps) => {
    const [isDialogOpen, setIsDialogOpen] = React.useState(false)

    const handleCloseDialog = () => {
        setIsDialogOpen(false)
    }

    const handleOpenDialog = () => {
        setIsDialogOpen(true)
    }

    return (
        <div>
            <IconButton onClick={handleOpenDialog}>
                <CloseOutlinedIcon />
            </IconButton>
            <Dialog open={isDialogOpen} onClose={handleCloseDialog}>
                <DialogTitle textAlign='center'>Opravdu chcete obrázek smazat?</DialogTitle>
                <DialogActions>
                    <Button onClick={handleCloseDialog}>Ne</Button>
                    <Button onClick={onRemove} variant='contained'>
                        Ano
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default RemoveImageDialog
